<template>
<layout-crumb :opts="[{label: task.siteName}, {label: $route.meta.label}]">
  <section class="selector-wrapper">
    <section class="selector-body">
      <van-cell-group v-if="taskMeasureInstrumentList.length > 0">
        <van-swipe-cell
          v-for="(taskMeasureInstrument, index) in taskMeasureInstrumentList"
          v-if="measureInstrumentMap[taskMeasureInstrument.measureInstrumentId]"
          :key="index"
        >
          <van-cell
            :title="measureInstrumentMap[taskMeasureInstrument.measureInstrumentId].name"
            :value="taskMeasureInstrument.measureInstrumentNumber"
            :label="`校准日期：${taskMeasureInstrument.calibrationTime}`"
            is-link
            @click="onMeasureInstrumentClick(taskMeasureInstrument)"
          />

          <template #right>
            <van-button square type="danger" text="删除" @click="onTaskMeasureInstrumentDelBtnClick(taskMeasureInstrument)" />
          </template>
        </van-swipe-cell>
      </van-cell-group>
      <van-empty v-else>
        <p class="van-empty__description" style="margin-top:-24px;">
          本次任务还未添加任何测量器具, 请点击下方的<span style="color:#FE7300;" @click="onCreateSiteDeviceBtnClick">添加测量器具</span>按钮
        </p>
      </van-empty>
    </section>

    <section class="selector-footer">
      <button class="back-btn" @click="onPreStepClick">返回仪器选择</button>
      <Abort />
      <button class="create-btn" @click="onCreateSiteDeviceBtnClick">添加测量器具</button>
      <button class="next-btn" @click="onNextStepClick">下一步</button>
    </section>
  </section>

  <van-action-sheet
    v-model="measureInstrumentSelectVisible"
    show-toolbar
    description="选择测量器具"
    :actions="[...measureInstrumentList, {id:'',name:'没有想要的测量器具？去添加新的测量器具',text:'没有想要的测量器具？去添加新的测量器具'}]"
    :style="{height:'100%'}"
    cancel-text="取消"
    @select="onMeasureInstrumentSelectSelect"
    @cancel="onMeasureInstrumentSelectCancel"
  />

  <van-popup
    v-if="measureInstrumentModel"
    v-model="measureInstrumentInputVisible"
    position="bottom"
    round
    closeable
  >
    <div style="font-size:16px;line-height:44px;padding:0 16px;">添加测量器具</div>
    <van-form @submit="onMeasureInstrumentSubmit">
      <van-field
        v-model="measureInstrumentModel.brand"
        name="测量器具品牌"
        label="测量器具品牌"
        placeholder="测量器具品牌"
        :rules="[{required:true,message:'请填写测量器具品牌'}]"
      />

      <van-field
        v-model="measureInstrumentModel.model"
        name="测量器具型号"
        label="测量器具型号"
        placeholder="测量器具型号"
        :rules="[{required:true,message:'请填写测量器具型号'}]"
      />

      <van-field
        v-model.number="measureInstrumentModel.a"
        type="number"
        name="斜率"
        label="斜率"
        placeholder="斜率"
      />

      <van-field
        v-model.number="measureInstrumentModel.b"
        type="number"
        name="截距"
        label="截距"
        placeholder="截距"
      />

      <van-field
        v-model.number="measureInstrumentModel.cc"
        type="number"
        name="相关系数"
        label="相关系数"
        placeholder="相关系数"
      />

      <div style="margin:16px;">
        <van-button round block type="info" native-type="submit">确定</van-button>
      </div>
    </van-form>
  </van-popup>

  <van-popup
    v-if="taskMeasureInstrumentModel"
    v-model="measureInstrumentSNVisible"
    position="bottom"
    round
    closeable
  >
    <div style="font-size:16px;line-height:44px;padding:0 16px;">添加测量器具</div>
    <van-form @submit="onTaskMeasureInstrumentSubmit">
      <van-field
        v-model="taskMeasureInstrumentModel.measureInstrumentNumber"
        name="序列号"
        label="序列号"
        placeholder="序列号"
        :rules="[{required:true,message:'请填写测量器具序列号'}]"
      />

      <div style="float:right;margin:-41px 16px 0 0;">
        <van-button
          type="primary"
          style="height:32px;"
          native-type="button"
          @click="onMeasureInstrumentInstancesBtnClick"
        >从列表中选择</van-button>
      </div>

      <van-field
        readonly
        clickable
        :value="taskMeasureInstrumentModel.calibrationTime"
        name="校准日期"
        label="校准日期"
        placeholder="校准日期"
        :rules="[{required:true,message:'请填写校准日期'}]"
        @click="dateSelectVisible = true"
      />

      <div style="margin:16px;">
        <van-button round block type="info" native-type="submit">确定</van-button>
      </div>
    </van-form>
  </van-popup>

  <van-popup
    v-if="taskMeasureInstrumentModel"
    v-model="dateSelectVisible"
    position="bottom"
    round
  >
    <van-datetime-picker
      v-model="calibrationTime"
      type="date"
      title="选择年月日"
      @confirm="onDateSelectConfirm"
    />
  </van-popup>

  <van-popup v-model="measureInstrumentInstancesSelectorLayerVisible" round style="width:65%;">
    <section v-if="measureInstrumentInstances.length > 0" style="font-size:16px;max-height:70%;padding:10px 0;line-height:22px;text-align:center;overflow:auto;">
      <div
        v-for="(measureInstrumentInstance, index) in measureInstrumentInstances"
        :key="index"
        class="measure-instrument-instance-select-item"
        @click="onMeasureInstrumentSelectItemClick(measureInstrumentInstance)"
      >{{measureInstrumentInstance.measureInstrumentNumber}}</div>
    </section>
    <section v-else style="font-size:16px;max-height:70%;padding:10px 0;line-height:22px;text-align:center;overflow:auto;">
      没有该测量器具的相关序列号
    </section>
  </van-popup>

  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>

</layout-crumb>
</template>

<script>
import {mapGetters} from 'vuex'
import {Toast} from 'vant'

export default {
  name: 'index',
  routeInfo: {
    label: '测量器具'
  },
  data () {
    return {
      measureInstrumentList: [],
      taskMeasureInstrumentList: [],
      overlayVisible: false,
      measureInstrumentSelectVisible: false,
      measureInstrumentInputVisible: false,
      measureInstrumentSNVisible: false,
      dateSelectVisible: false,
      measureInstrumentModel: null,
      taskMeasureInstrumentModel: null,
      calibrationTime: new Date(),
      measureInstrumentInstances: [],
      measureInstrumentInstancesSelectorLayerVisible: false
    }
  },
  computed: {
    ...mapGetters({
      task: 'Task/task',
      orgId: 'Profile/orgId'
    }),
    measureInstrumentMap () {
      return this.measureInstrumentList.reduce((map, measureInstrument) => {
        map[measureInstrument.id] = measureInstrument
        return map
      }, {})
    }
  },
  methods: {
    getMeasureInstrumentModel () {
      return {
        id: '',
        brand: '',
        model: '',
        orgId: this.orgId
      }
    },
    getTaskMeasureInstrumentModel () {
      return {
        measureInstrumentId: '',
        measureInstrumentBrand: '',
        measureInstrumentModel: '',
        measureInstrumentName: '',
        measureInstrumentNumber: '',
        calibrationTime: new Date().format('YYYY/MM/DD'),
        taskId: this.task.id,
        a: 1,
        b: 0,
        cc: 1,
        isShow: true
      }
    },
    onPreStepClick () {
      let taskMeasureInstrumentList = this.taskMeasureInstrumentList

      if (taskMeasureInstrumentList.length > 0) {
        this.overlayVisible = true

        this.$api.TaskMeasureInstrument.batchSave(this.taskMeasureInstrumentList).then(data => {
          if (data) {
            this.$router.replace({
              name: 'DeviceSelector'
            })
          }
        }).catch(console.error).finally(() => {
          this.overlayVisible = false
        })
      } else {
        this.$router.replace({
          name: 'DeviceSelector'
        })
      }
    },
    onCreateSiteDeviceBtnClick () {
      this.taskMeasureInstrumentModel = this.getTaskMeasureInstrumentModel()
      this.currentTaskMeasureInstrument = null
      this.measureInstrumentSelectVisible = true
    },
    onNextStepClick () {
      if (this.taskMeasureInstrumentList.length === 0) {
        return Toast('请添加测量器具')
      }

      this.overlayVisible = true

      this.$api.TaskMeasureInstrument.batchSave(this.taskMeasureInstrumentList).then(data => {
        if (data) {
          this.$router.replace({
            name: 'SiteEnvPhoto'
          })
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    getMeasureInstrumentList () {
      this.$api.MeasureInstrument.getList({
        orgId: this.orgId
      }).then(measureInstrumentList => {
        measureInstrumentList.forEach(measureInstrument => {
          measureInstrument.text = measureInstrument.name
        })
        this.measureInstrumentList = Object.freeze(measureInstrumentList)
      })
    },
    setMeasureInstrument (measureInstrument) {
      let taskMeasureInstrumentModel = this.taskMeasureInstrumentModel
      taskMeasureInstrumentModel.measureInstrumentId = measureInstrument.id
      taskMeasureInstrumentModel.measureInstrumentBrand = measureInstrument.brand
      taskMeasureInstrumentModel.measureInstrumentModel = measureInstrument.model
      taskMeasureInstrumentModel.measureInstrumentName = measureInstrument.name
      taskMeasureInstrumentModel.a = measureInstrument.a || 1
      taskMeasureInstrumentModel.b = measureInstrument.b || 0
      taskMeasureInstrumentModel.cc = measureInstrument.cc || 1
      taskMeasureInstrumentModel.isShow = true
      this.measureInstrumentSNVisible = true
    },
    onMeasureInstrumentSelectSelect (measureInstrument) {
      let measureInstrumentId = measureInstrument.id

      if (measureInstrumentId) {
        this.setMeasureInstrument(measureInstrument)
      } else {
        this.measureInstrumentModel = this.getMeasureInstrumentModel()
        this.measureInstrumentInputVisible = true
      }

      this.measureInstrumentSelectVisible = false
    },
    onMeasureInstrumentSelectCancel () {
      this.measureInstrumentInputVisible = false
    },
    onMeasureInstrumentSubmit () {
      this.overlayVisible = true

      this.$api.MeasureInstrument.save(this.measureInstrumentModel, 1).then(measureInstrument => {
        if (measureInstrument) {
          this.getMeasureInstrumentList()
          this.measureInstrumentModel = null
          this.setMeasureInstrument(measureInstrument)
          this.measureInstrumentInputVisible = false
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onDateSelectConfirm () {
      this.taskMeasureInstrumentModel.calibrationTime = this.calibrationTime.format('YYYY/MM/DD')
      this.dateSelectVisible = false
    },
    onTaskMeasureInstrumentSubmit () {
      let {currentTaskMeasureInstrument, taskMeasureInstrumentModel} = this

      if (currentTaskMeasureInstrument) {
        for (let key in taskMeasureInstrumentModel) {
          currentTaskMeasureInstrument[key] = taskMeasureInstrumentModel[key]
        }
      } else {
        this.taskMeasureInstrumentList.push(taskMeasureInstrumentModel)
      }

      this.taskMeasureInstrumentModel = null
      this.currentTaskMeasureInstrument = null
      this.measureInstrumentSNVisible = false
    },
    onTaskMeasureInstrumentDelBtnClick (taskMeasureInstrument) {
      let taskMeasureInstrumentList = this.taskMeasureInstrumentList
      let index = taskMeasureInstrumentList.indexOf(taskMeasureInstrument)

      if (index > -1) {
        taskMeasureInstrumentList.splice(index, 1)
      }
    },
    onMeasureInstrumentClick (taskMeasureInstrument) {
      this.taskMeasureInstrumentModel = {
        ...taskMeasureInstrument
      }
      this.currentTaskMeasureInstrument = taskMeasureInstrument
      this.calibrationTime = new Date(taskMeasureInstrument.calibrationTime)
      this.measureInstrumentSNVisible = true
    },
    requestInstance (measureInstrumentId) {
      this.overlayVisible = true
      this.$api.MeasureInstrument.getInstanceById(this.task.year, measureInstrumentId).then(data => {
        this.measureInstrumentInstances = Object.freeze(data)
        this.measureInstrumentInstancesSelectorLayerVisible = true
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onMeasureInstrumentInstancesBtnClick (event) {
      this.requestInstance(this.taskMeasureInstrumentModel.measureInstrumentId)
    },
    onMeasureInstrumentSelectItemClick (measureInstrumentInstance) {
      let {taskMeasureInstrumentModel} = this
      taskMeasureInstrumentModel.calibrationTime = measureInstrumentInstance.calibrationTime
      taskMeasureInstrumentModel.measureInstrumentNumber = measureInstrumentInstance.measureInstrumentNumber
      taskMeasureInstrumentModel.a = measureInstrumentInstance.a
      taskMeasureInstrumentModel.b = measureInstrumentInstance.b
      taskMeasureInstrumentModel.cc = measureInstrumentInstance.cc
      taskMeasureInstrumentModel.isShow = measureInstrumentInstance.isShow
      this.measureInstrumentInstancesSelectorLayerVisible = false
    }
  },
  created () {
    this.getMeasureInstrumentList()

    this.$api.TaskMeasureInstrument.getList({
      taskId: this.task.id
    }).then(taskMeasureInstrumentList => {
      this.taskMeasureInstrumentList = taskMeasureInstrumentList || []
    })
  }
}
</script>

<style lang="scss" scoped>
.selector-wrapper {
  .selector-body {
    padding: 1rem;
    border-bottom: 1px solid #cfd0d3;
    background-color: #f7f8fa;
  }
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}

.measure-instrument-instance-select-item {
  padding: 14px 16px;
  cursor: pointer;

  &:hover {
    background-color: #f5f7fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05MeasureInstrumentSelector/index.vue